export enum TeamsActions {
  SET_TEAMS = "SET_TEAMS",
  ADD_TEAMS = "ADD_TEAMS",
  UPDATE_TEAMS = "UPDATE_TEAMS",
  DELETE_TEAMS = "DELETE_TEAMS",
  CREATE_TEAM = "CREATE_TEAM",
}
